import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';


class Api extends Component {
	render() {
		console.dir(this);
		return (
			<div>
				API
			</div>
		);
	}
}

export default branch({}, Api);




// WEBPACK FOOTER //
// ./src/pages/Api.js